import { Exporting } from './exporting';
import { PeakPicking } from './peak-picking';
import { Phasing } from './phasing';

export const Menus = {
  PeakPicking,
  Phasing,
  Exporting
};
